var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "min-h-100vh flex flex-col",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "fixed w-full z-99999"
  }, [_c('NavBar', {
    attrs: {
      "showOperation": _vm.$route.meta.navBarOperation
    }
  })], 1), _c('div', {
    staticClass: "flex-1 mt-120px"
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1), !_vm.$route.meta.hiddenFoot ? _c('FootBar', {
    staticStyle: {
      "min-width": "1200px"
    }
  }) : _vm._e(), !_vm.isHomePage ? _c('FloatingServiceMenu') : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };